import React from 'react';
import ReactDOM from 'react-dom';
import {mainNavRef} from '../../../pages/block-references';
import {ClassroomVideoStore} from './ClassroomVideoStore';
import {LocalVideo} from './LocalVideo';
import {LocalVideoControls} from './LocalVideoControls';
import {RemoteVideo} from './RemoteVideo';
import {RemoteVideoControls} from './RemoteVideoControls';

export class ClassroomVideo extends React.Component<{ store: ClassroomVideoStore }> {
  render() {
    if (mainNavRef.current === null)
      return null;

    const store = this.props.store;
    const result =
      <div className="classroom-video" key="classroom-video">
        <RemoteVideo store={store} key="remote-video"/>
        <RemoteVideoControls store={store} key="remote-video-controls"/>

        <LocalVideo store={store} key="local-video"/>
        <LocalVideoControls store={store} key="local-video-controls"/>
      </div>;

    return ReactDOM.createPortal(result,
      mainNavRef.current);
  }
}
